module.exports = __webpack_public_path__ + "img/bx-share1.9b80675a.svg";